import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Trash
 */

export default function TrashIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <svg height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
        <path
          clipRule="evenodd"
          d="M5.81348 2V1H9.81348V2H5.81348ZM4.81348 2V0.5C4.81348 0.223858 5.03733 0 5.31348 0H10.3135C10.5896 0 10.8135 0.223858 10.8135 0.5V2H12.3135H14.8135C15.0896 2 15.3135 2.22386 15.3135 2.5C15.3135 2.77614 15.0896 3 14.8135 3H12.8135V15.5C12.8135 15.7761 12.5896 16 12.3135 16H3.31348C3.03733 16 2.81348 15.7761 2.81348 15.5V3H0.813477C0.537334 3 0.313477 2.77614 0.313477 2.5C0.313477 2.22386 0.537334 2 0.813477 2H3.31348H4.81348ZM10.3135 3H5.31348H3.81348V15H11.8135V3H10.3135ZM7.81348 5.5C8.08962 5.5 8.31348 5.72386 8.31348 6L8.31348 12C8.31348 12.2761 8.08962 12.5 7.81348 12.5C7.53733 12.5 7.31348 12.2761 7.31348 12L7.31348 6C7.31348 5.72386 7.53733 5.5 7.81348 5.5ZM10.3135 6C10.3135 5.72386 10.0896 5.5 9.81348 5.5C9.53733 5.5 9.31348 5.72386 9.31348 6V12C9.31348 12.2761 9.53733 12.5 9.81348 12.5C10.0896 12.5 10.3135 12.2761 10.3135 12V6ZM5.81348 5.5C6.08962 5.5 6.31348 5.72386 6.31348 6L6.31348 12C6.31348 12.2761 6.08962 12.5 5.81348 12.5C5.53733 12.5 5.31348 12.2761 5.31348 12L5.31348 6C5.31348 5.72386 5.53733 5.5 5.81348 5.5Z"
          fillRule="evenodd"
        />
      </svg>
    </Icon>
  );
}
